var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { combineReducers } from "redux";
import { TypeActionPlayerBase } from "./actionPlayerBase";
import { reducerBuildings } from "./buildings/reducerBuildings";
import { reducerExpansions } from "./expansions/reducerExpansions";
var initial = {
    baseId: -1,
};
export var reducerBase = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionPlayerBase.SelectBase:
            return __assign({}, state, { baseId: action.baseId });
        default:
            return state;
    }
};
export var reducerPlayerBase = combineReducers({
    base: reducerBase,
    buildings: reducerBuildings,
    expansions: reducerExpansions,
});



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/reducerPlayerBase.ts
// module id = 2968
// module chunks = 3